module.exports = __webpack_public_path__ + "media/bootstrap-icons/eraser-fill-3567b967.svg";